import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth-service.service';
import { catchError } from 'rxjs/operators';
import { environment } from "@env/environment";

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

  constructor(
   private authService: AuthService
  ){ }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let needsAuth = true
    if (
        req.url.includes('/auth') ||
        req.url.includes(`${environment.baseAPIUrl}caretaker/recover-password`) ||
        req.url.includes(`${environment.baseAPIUrl}caretaker/reset-password`)
    ) {
      needsAuth = false
    }
    if (needsAuth) {
      const token = this.authService.getAccessToken();
      if (token) {
        req = req.clone({
          headers: req.headers.set('Authorization', `Bearer ${this.authService.getAccessToken()}`)
        });
      } else {
        return next.handle(req).pipe(
          catchError(error => { // if no token => logout
            return this.authService.errorHandler(error);
          })
        );
      }
    }
    return next.handle(req).pipe(
      catchError(error => {
        if (error.status === 401) { // if anytime backend tell us that token is wrong => logout
          return this.authService.errorHandler(error);
        }
        throw error;
      })
    );
  }
}
